module.exports = __webpack_public_path__ + "static/media/plusrounded.61136e32.svg";